var map = {
	"./decidim/avatar-multiuser.png": 1324,
	"./decidim/brands/google.svg": 80579,
	"./decidim/cc-badge.png": 60446,
	"./decidim/decidim-logo.svg": 76462,
	"./decidim/default-avatar.svg": 93466,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 73006,
	"./decidim/icons.svg": 6413,
	"./decidim/pattern.png": 47594,
	"./decidim/placeholder-card-g.svg": 58151,
	"./decidim/placeholder-card-l.svg": 72892,
	"./decidim/placeholder.jpg": 55907,
	"./decidim/remixicon.symbol.svg": 32939,
	"./decidim/vendor/leaflet/layers-2x.png": 6222,
	"./decidim/vendor/leaflet/layers.png": 97813,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 87612,
	"./decidim/vendor/leaflet/marker-icon.png": 11979,
	"./decidim/vendor/leaflet/marker-shadow.png": 48880,
	"./decidim/vendor/social-share-button/douban.svg": 82298,
	"./decidim/vendor/social-share-button/email.svg": 50743,
	"./decidim/vendor/social-share-button/facebook.svg": 18601,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 51595,
	"./decidim/vendor/social-share-button/hacker_news.svg": 14299,
	"./decidim/vendor/social-share-button/linkedin.svg": 10951,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 86944,
	"./decidim/vendor/social-share-button/pinterest.svg": 33849,
	"./decidim/vendor/social-share-button/reddit.svg": 97865,
	"./decidim/vendor/social-share-button/telegram.svg": 50384,
	"./decidim/vendor/social-share-button/tumblr.svg": 22311,
	"./decidim/vendor/social-share-button/twitter.svg": 14918,
	"./decidim/vendor/social-share-button/vkontakte.svg": 5688,
	"./decidim/vendor/social-share-button/wechat.svg": 5987,
	"./decidim/vendor/social-share-button/whatsapp.svg": 15067,
	"./decidim/vendor/social-share-button/x.svg": 49647,
	"./decidim/vendor/social-share-button/xing.svg": 76041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69335;